import { useSyncExternalStore } from 'react';

// Che do hien bang tren dien thoai (chu 2026-09-27): 'danh-sach' = bang gon cuon ngang, moi dong
// mot tai khoan (mac dinh, nhu Tele88); 'the' = moi dong thanh mot the. Nho theo trinh duyet.
// Ap dung qua lop `che-do-the` tren <html> (styles.scss), nen moi bang deu theo.
export type CheDoDs = 'danh-sach' | 'the';
export const KHOA_CHE_DO = 'ruby.cheDoDs';
export const LOP_THE = 'che-do-the';

type KhoLuu = Pick<Storage, 'getItem' | 'setItem'>;
function kho(): KhoLuu | null {
  try {
    return typeof localStorage === 'undefined' ? null : localStorage;
  } catch {
    return null;
  }
}

export function docCheDo(k: KhoLuu | null = kho()): CheDoDs {
  try {
    return k?.getItem(KHOA_CHE_DO) === 'the' ? 'the' : 'danh-sach';
  } catch {
    return 'danh-sach';
  }
}

let hienTai: CheDoDs = docCheDo();
const nghe = new Set<() => void>();

function apDung() {
  if (typeof document !== 'undefined') document.documentElement.classList.toggle(LOP_THE, hienTai === 'the');
}
apDung();

export function datCheDo(c: CheDoDs, k: KhoLuu | null = kho()) {
  try {
    k?.setItem(KHOA_CHE_DO, c);
  } catch {
    // trinh duyet chan luu tru: van doi trong phien nay
  }
  hienTai = c;
  apDung();
  nghe.forEach((f) => f());
}

export function layCheDo(): CheDoDs {
  return hienTai;
}

// tab khac doi che do: nghe ngay tu luc nap trang, ke ca khi chua co nut nao dang hien
if (typeof window !== 'undefined') {
  window.addEventListener('storage', (e) => {
    if (e.key !== KHOA_CHE_DO && e.key !== null) return;
    hienTai = docCheDo();
    apDung();
    nghe.forEach((f) => f());
  });
}

function theoDoi(f: () => void) {
  nghe.add(f);
  return () => {
    nghe.delete(f);
  };
}

export function useCheDoDs(): CheDoDs {
  return useSyncExternalStore(theoDoi, layCheDo, () => 'danh-sach');
}
